import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output, Signal, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NhptDataSet, TwoHandsNumberDataSet } from '../../../services/model';
import { MatIcon } from '@angular/material/icon';
import { NumbersOnlyDirective } from '../../../directives/numbers-only.diretive';

type TwoHandsRowHtml = TwoHandsNumberDataSet & {
  controlRightName: string;
  controlLeftName: string;
};

@Component({
  selector: 'app-dynamic-table-input-nhpt',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatIcon,
    NumbersOnlyDirective,
  ],
  templateUrl: './dynamic-table-input-nhpt.component.html',
  styleUrl: './dynamic-table-input-nhpt.component.scss',
})
export class DynamicTableInputNhptComponent implements OnInit {
  private fb: UntypedFormBuilder = inject(UntypedFormBuilder);
  @Input() title: string | undefined = '';
  @Input() data: Array<NhptDataSet> = [];
  @Input() note: string = '';
  @Input() manual: string | undefined = '';
  @Input() startTabIndex: number = 0;
  @Input() isTwoSided = true;
  @Output() inputData = new EventEmitter<{ data: Array<NhptDataSet>; note: string; hasError: boolean }>(true);
  dataHtml: Array<TwoHandsRowHtml> = [];
  form: FormGroup = new FormGroup({});
  formDataOld: any = {};
  isOverMaxTimeLeft: boolean = false;
  isOverMaxTimeRight: boolean = false;

  private valueChanges: Signal<unknown> | undefined;
  // private formDataEffect = effect(() => {
  //   console.log('value Changes', this.valueChanges());

  //   this.inputData.emit(this.valueChanges());
  // });
  constructor(private injector: Injector) {}

  ngOnInit() {
    this.form = this.fb.group({
      ...this.data
        .flatMap(row => {
          return [
            {
              [row.name + '_left']: [
                this.getValue(row.valueLeft),
                { updateOn: 'change', validators: [Validators.min(0), Validators.max(60)] },
              ],
            },
            {
              [row.name + '_right']: [
                this.getValue(row.valueRight),
                { updateOn: 'change', validators: [Validators.min(0), Validators.max(60)] },
              ],
            },
            {
              [row.name + '_leftRest']: [
                this.getValue(row.overtimeCountLeft),
                { updateOn: 'change', validators: [Validators.min(0), Validators.max(18)] },
              ],
            },
            {
              [row.name + '_rightRest']: [
                this.getValue(row.overtimeCountRight),
                { updateOn: 'change', validators: [Validators.min(0), Validators.max(18)] },
              ],
            },
            { [row.name + '_leftOvertime']: [this.getOvertime(row.valueLeft)] },
            { [row.name + '_rightOvertime']: [this.getOvertime(row.valueRight)] },
            { [row.name + '_leftErsteHaelfte']: [this.getIsErsteHaelfte(row.valueLeft)] },
            { [row.name + '_rightErsteHaelfte']: [this.getIsErsteHaelfte(row.valueRight)] },
            // { [row.name + '_leftRest']: [this.getRest(row.valueLeft), Validators.min(0), Validators.max(9)] },
            // { [row.name + '_rightRest']: [this.getRest(row.valueRight), Validators.min(0), Validators.max(9)] },
          ];
        })
        .reduce((prev, current) => {
          const [key] = Object.keys(current);
          const value = current[key];
          prev[key] = value;
          return prev;
        }, {}),
      // note: [this.note],
    });

    this.valueChanges = toSignal(this.form.valueChanges, { injector: this.injector });
    this.formDataOld = this.form.value;

    effect(
      () => {
        const formData = this.valueChanges!() as object;
        console.log('formData valueChanges newData', formData);
        console.log('formData valueChanges oldData', this.formDataOld);
        if (formData) {
          const newData: Array<NhptDataSet> = [];
          this.data.forEach((row, zeroBasedIndex) => {
            const index = zeroBasedIndex + 1;
            const propLeft = 'test' + index + '_left';
            const propRight = 'test' + index + '_right';
            const propleftRest = 'test' + index + '_leftRest';
            const proprightRest = 'test' + index + '_rightRest';

            let valueLeft: number | null = this.hasDynamicProperty(formData, propLeft)
              ? (formData[propLeft] as number)
              : null;
            let valueRight: number | null = this.hasDynamicProperty(formData, propRight)
              ? (formData[propRight] as number)
              : null;
            let valueLeftRest: number | null = this.hasDynamicProperty(formData, propleftRest)
              ? (formData[propleftRest] as number)
              : null;
            let valueRightRest: number | null = this.hasDynamicProperty(formData, proprightRest)
              ? (formData[proprightRest] as number)
              : null;

            // ----------------
            // left
            const propleftOvertime = 'test' + index + '_leftOvertime';
            let leftOvertime: boolean = this.hasDynamicProperty(formData, propleftOvertime)
              ? (formData[propleftOvertime] as boolean)
              : false;
            const leftOvertimeChanged: boolean = (this.formDataOld[propleftOvertime] as boolean) !== leftOvertime;

            if (leftOvertime && leftOvertimeChanged) {
              valueLeft = 60;
              this.form.controls[propLeft].setValue(valueLeft, { emitEvent: false, onlySelf: true });
            }
            if (!leftOvertime && leftOvertimeChanged) {
              valueLeft = 0;
              this.form.controls[propLeft].setValue(valueLeft, { emitEvent: false, onlySelf: true });
            }
            if (valueLeft !== null && valueLeft >= 60 && leftOvertime === false) {
              leftOvertime = true;
              this.form.controls[propleftOvertime].setValue(leftOvertime, { emitEvent: false, onlySelf: true });
            }
            if (valueLeft !== null && valueLeft < 60) {
              valueLeftRest = null;
              this.form.controls[propleftRest].setValue(valueLeftRest, { emitEvent: false, onlySelf: true });
            }
            if (valueLeft !== null && valueLeft < 60 && leftOvertime === true) {
              leftOvertime = false;
              this.form.controls[propleftOvertime].setValue(leftOvertime, { emitEvent: false, onlySelf: true });
            }

            // ----------------
            // right
            const proprightOvertime = 'test' + index + '_rightOvertime';
            let rightOvertime: boolean = this.hasDynamicProperty(formData, proprightOvertime)
              ? (formData[proprightOvertime] as boolean)
              : false;
            const rightOvertimeChanged: boolean = (this.formDataOld[proprightOvertime] as boolean) !== rightOvertime;

            if (rightOvertime && rightOvertimeChanged) {
              valueRight = 60;
              this.form.controls[propRight].setValue(valueRight, { emitEvent: false, onlySelf: true });
            }
            if (!rightOvertime && rightOvertimeChanged) {
              valueRight = 0;
              this.form.controls[propRight].setValue(valueRight, { emitEvent: false, onlySelf: true });
            }
            if (valueRight !== null && valueRight >= 60 && rightOvertime === false) {
              rightOvertime = true;
              this.form.controls[proprightOvertime].setValue(rightOvertime, { emitEvent: false, onlySelf: true });
            }
            if (valueRight !== null && valueRight < 60) {
              valueRightRest = null;
              this.form.controls[proprightRest].setValue(valueRightRest, { emitEvent: false, onlySelf: true });
            }
            if (valueRight !== null && valueRight < 60 && rightOvertime === true) {
              rightOvertime = false;
              this.form.controls[proprightOvertime].setValue(rightOvertime, { emitEvent: false, onlySelf: true });
            }

            newData.push({
              ...row,
              valueLeft,
              valueRight,
              overtimeCountLeft: valueLeftRest,
              overtimeCountRight: valueRightRest,
            });

            this.formDataOld = {
              ...this.form.value,
              [propLeft]: valueLeft,
              [propleftOvertime]: leftOvertime,
              [propRight]: valueRight,
              [proprightOvertime]: rightOvertime,
            };
          });
          // const note: string = this.hasDynamicProperty(formData, 'note') ? formData['note'] : '';
          const note: string = '';
          this.inputData.emit({ note, data: newData, hasError: this.form.status === 'INVALID' ? true : false });
        }
      },
      { injector: this.injector }
    );

    this.dataHtml = this.data.map(row => {
      return { ...row, controlLeftName: row.name + '_left', controlRightName: row.name + '_right' };
    });
  }

  hasDynamicProperty(obj: any, propName: string): obj is { [key: string]: any } {
    return typeof obj === 'object' && obj !== null && propName in obj;
  }

  getValue(value: number | null): number | null {
    if (value === null) {
      return value;
    }
    if (value < 0 || value > 61) {
      return 61;
    }
    return value;
  }
  getRest(value: number | null): number {
    const val = value ?? 0;
    if (val < 0) {
      const fullRest = val * -1;
      return fullRest > 9 ? fullRest - 9 : fullRest;
    }
    return -1;
  }
  getOvertime(value: number | null): boolean {
    const val = value ?? 0;
    if (val >= 60) {
      return true;
    }
    return false;
  }
  getIsErsteHaelfte(value: number | null): boolean {
    const val = value ?? 0;
    if (val < -9) {
      return false;
    }
    return true;
  }

  getMinMAxValue(value: number | null, row: TwoHandsNumberDataSet): number | null {
    if (row.min !== null && row.min !== undefined && row.max !== null && row.max !== undefined && value !== null) {
      if (value > row.max) {
        return row.max;
      } else if (value < row.min) {
        return row.min;
      } else {
        return value;
      }
    } else {
      return value;
    }
  }

  onInputChange($event: any, controlName: string, row: TwoHandsNumberDataSet) {
    console.log('onInputChange', row);

    if ($event.target) {
      if ($event.target.value === '') {
        return;
      } else {
        console.log('$event.target.value', $event.target.value);
        $event.target.value = this.getMinMAxValue(Number($event.target.value), row);
        this.form.controls[controlName].patchValue(this.getMinMAxValue(Number($event.target.value), row));
      }
    }
  }
}
